/* eslint-disable no-inner-declarations */
import animations from '../modules/animations.js';
import lightbox from '../modules/lightbox.js';
import drag from '../modules/drag.js';
import interactivemap from '../modules/interactivemap.js';
import trapFocus from '../modules/trapfocus.js';

export default {
  init() {
    animations();
    lightbox();
    drag();
    interactivemap();
    // JavaScript to be fired on the home page

    // Trap focus inside the navigation menu on mobile
    const burgerButton = document.querySelector('.navbar-burger');
    if(burgerButton){
      trapFocus(document.querySelector('.navbar-menu'), burgerButton, 'is-active');
    }

    // Trap focus inside the language selector modal
    const languageOverlay = document.querySelector('.overlaySingle');
    if(languageOverlay){
      // trapFocus(languageOverlay, languageOverlay);
    }

    // Trap focus inside the Popup that appears on the Map
    const mapPopup = document.querySelector('.popup');
    if(mapPopup){
      trapFocus(mapPopup, mapPopup, 'showpopup');
    }

    // Trap focus inside the Places submenu is present on the Map
    const menuAllplaces = document.querySelector('.menu-allplaces');
    if(menuAllplaces){
      trapFocus(menuAllplaces, document.querySelector('.controlMap'), 'openMapMenu');
    }

    // Toggle aria-expanded attribute value
    function toggle_aria_expanded(element) {
      const state = element.getAttribute('aria-expanded');
      if(state == 'true'){
        element.setAttribute('aria-expanded', 'false');
      } else {
        element.setAttribute('aria-expanded', 'true');
      }
    }

    $('.navbar-burger').on('click', function() {
      // Toggle the 'is-active' class on both the 'navbar-burger' and the 'navbar-menu'
      $('.navbar-burger').toggleClass('is-active');
      $('.navbar-menu').toggleClass('is-active');

      toggle_aria_expanded(document.querySelector('.navbar-burger'));
  });

    // Close mobile menu with ESC key
    $(document).on('keyup', function(e){
      if(e.key == 'Escape'){
        $('.navbar-burger').removeClass('is-active');
        $('.navbar-menu').removeClass('is-active');
        $('.navbar-burger').attr('aria-expanded', 'false');
      }
    });

    $('a[href*=#]').on('click', function(e) {
       e.preventDefault();
       $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top}, 500, 'linear');
     });

  },
  finalize() {


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js